import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AppProvider } from "@/context/AppContext";
import SiteLayout from "@/components/layout/SiteLayout";
import Directory from "@/pages/Directory";
import ActivityOverview from "@/pages/ActivityOverview";
import OrganizerHub from "@/pages/OrganizerHub";
import PhaseGuide from "@/pages/PhaseGuide";
import VolunteerFlow from "@/pages/VolunteerFlow";
import PrintableGuide from "@/pages/PrintableGuide";

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          {/* Standalone print views (no site chrome so they print cleanly) */}
          <Route path="/activities/:slug/organizer/drop-in/print" element={<PrintableGuide mode="drop-in" />} />
          <Route path="/activities/:slug/organizer/self-hosted/print" element={<PrintableGuide mode="self-hosted" />} />
          <Route element={<SiteLayout />}>
            {/* Activity-first entry: the Choose an Activity grid is the landing page */}
            <Route path="/" element={<Directory />} />
            <Route path="/activities" element={<Directory />} />
            <Route path="/activities/:slug" element={<ActivityOverview />} />
            <Route path="/activities/:slug/organizer" element={<OrganizerHub />} />
            <Route path="/activities/:slug/organizer/drop-in" element={<PhaseGuide mode="drop-in" />} />
            <Route path="/activities/:slug/organizer/self-hosted" element={<PhaseGuide mode="self-hosted" />} />
            <Route path="/activities/:slug/volunteer" element={<VolunteerFlow />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0D1B33",
            color: "#ffffff",
            border: "1px solid rgba(255,255,255,0.1)",
          },
        }}
      />
    </AppProvider>
  );
}

export default App;
